import React from "react";
import { useParams } from "react-router-dom";
import PartnershipChatScreen from "../../../../Components/ChatComponents/PartnershipChatScreen";
/**
 * Streamlined Creator-specific Partnership view
 * Now just a wrapper around the unified PartnershipChatScreen
 */
const CreatorSpecificPartnership = () => {
  const { partnershipId } = useParams();

  return (
    <PartnershipChatScreen
      partnershipId={partnershipId}
      sx={{
        backgroundColor: "#fafafa",
      }}
    />
  );
};

export default CreatorSpecificPartnership;